import Headertop from './../Headers/index.vue'

export default {
  name: 'project',
  props: [],
  components: {
    Headertop,
  },
  mounted() {
  },
  data() {
    return {
      wallets: {
        bitCoin: "1BjxQmG2fZvvJNujrynZEfYJR3nFES9N9X",
        ethereum: "0x7a9064d16f7ec8d46c4d4008741c5a56093dddaa",
        solarCoin: "8KgozePHFNRTa4o3moWhY53XpD8pbeoCy1",
      },
      formToSend: {
        user: {
          fullName: "",
          email: "",
          address: "",
        },
        wallet: {
          type: "ethereum", // default type is ethereum
          symbol: "ETH", // default type is ethereum
          sendingAddress: "",
          receivingAddress: "",
          priceInCoin: 0,
        },
        numberOfSolarPets: "1",
        message: "", // message for display and send to email
      },
      priceInUSD: 50.66,
      coinmarketcap: null, // data from https://coinmarketcap.com
    }
  },
  filters: {
  },
  methods: {
    orderNow: function (event) {
      this.$validator.validateAll()

      if (!this.errors.any()) {
        $('#orderNowModal').modal('show')
      }
    },

    sendOrder: function (event) {
      $('#orderNowModal').modal('hide')
      $('#sendModal').modal('show')

      this.calculateCoins()

      this.formToSend.message = "Please send " + this.formToSend.wallet.priceInCoin + " " + this.formToSend.wallet.symbol
      + "</br>number of SolarPets: " + this.formToSend.numberOfSolarPets
      + "</br>from address: " + this.formToSend.wallet.sendingAddress
      + "</br>to the address: " + this.formToSend.wallet.receivingAddress
      + "</br></br>"
      + "<b>Important: Please note that only transfers from the wallet address you entered will be counted.    To change address please start a new order.</b>"
      ;

      let data = {};
      data.priceInCoin = this.formToSend.wallet.priceInCoin;
      data.walletSymbol = this.formToSend.wallet.symbol;
      data.numberOfSolarPets = this.formToSend.numberOfSolarPets;
      data.walletSendingAddress = this.formToSend.wallet.sendingAddress;
      data.walletReceivingAddress = this.formToSend.wallet.receivingAddress;

      this.$http.post('/api/sendSolarPet', data)
        .then(
          response => {
            // this.sendmail(data);
            setTimeout(() => {
              var _s = this
              var url = "/uploads/"+ response.body;
              this.$localStorage.set('udata', JSON.stringify(this.userdata))
              this.$router.push({ name: 'Agreement', params: { url: url }})
            }, 1000)
          },
          error => {
            console.log("NO")
            console.log(error)
          })
    },

    changeWallet: function () {
      this.calculateCoins()
    },

    calculateCoins: function () {
      var usdToCoin = 0;
      switch(this.formToSend.wallet.type) {
        case 'bitcoin': {
          usdToCoin = this.coinmarketcap.bitcoin.price_usd
          this.formToSend.wallet.symbol = this.coinmarketcap.bitcoin.symbol
          this.formToSend.wallet.receivingAddress = this.wallets.bitCoin
        } break;

        case 'ethereum': {
          usdToCoin = this.coinmarketcap.ethereum.price_usd
          this.formToSend.wallet.symbol = this.coinmarketcap.ethereum.symbol
          this.formToSend.wallet.receivingAddress = this.wallets.ethereum
        } break;

        case 'solarcoin': {
          usdToCoin = this.coinmarketcap.solarcoin.price_usd
          this.formToSend.wallet.symbol = this.coinmarketcap.solarcoin.symbol
          this.formToSend.wallet.receivingAddress = this.wallets.solarCoin
        } break;

        default: {
          throw "Not found price for select coin."
        } break;
      }

      this.formToSend.wallet.priceInCoin = this.formToSend.numberOfSolarPets * (this.priceInUSD / usdToCoin);
    },
  },
  computed: {
  },
  beforeCreate() {},
  created() {
    this.$http.get('/api/current_user')
      .then(
        response => {
          console.log("response from '/api/current_user'")
          console.log(response)

          this.formToSend.user.email = response.data.user.email

          if (response.data.user.fullName)
            this.formToSend.user.fullName = response.data.user.fullName

          if (response.data.user.address)
            this.formToSend.user.address = response.data.user.address
        },
        error => {
          this.validationMessage = "I can not get access to the price.";
          console.error(error);
        });

    this.$http.get('/api/coinmarketcap')
      .then(
        response => {
          console.log("response from '/api/coinmarketcap'")
          console.log(response)

          this.coinmarketcap = response.data;
          this.calculateCoins()
          this.$validator.validateAll()
        },
        error => {
          this.validationMessage = "I can not get access to the price.";
          console.error(error);
        });

    if (typeof web3 !== 'undefined') {
      window.web3 = new Web3(web3.currentProvider)
      var _s = this;
      console.log(_s)

      web3.net.getListening(function(error, result) {
        if(!error && result) {
          if(typeof web3.eth.defaultAccount !== 'undefined') {
            _s.formToSend.wallet.sendingAddress = web3.eth.defaultAccount;
          } else {
            console.log('Please unlock Metamask and refresh the page!');
          }
        }
      })
    } else {
      console.log('Please unlock Metamask and refresh the page!');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductSolarPet/ProductSolarPet.component.js